// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__3AFqA","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__X4Sgp"};